// extracted by mini-css-extract-plugin
export var arrow = "Card-module--arrow--11ec7";
export var card = "Card-module--card--59d6f";
export var content = "Card-module--content--d6944";
export var darkTheme = "Card-module--dark--theme--51264";
export var grow = "Card-module--grow--7e34b";
export var icon = "Card-module--icon--4c34c";
export var iconArrow = "Card-module--icon-arrow--716ab";
export var large = "Card-module--large--5221d";
export var link = "Card-module--link--069fd";
export var readMore = "Card-module--read-more--d9a9a";
export var rightBounce = "Card-module--right-bounce--189f5";
export var squeeze = "Card-module--squeeze--50650";
export var stack = "Card-module--stack--4a70b";
export var thumbnail = "Card-module--thumbnail--9b696";
export var thumbnailBounds = "Card-module--thumbnail-bounds--8edc3";